import { useMemo, useState } from "react";
import { AutoComplete } from "@/core/components/ui/autocomplete";
import { useGetCustomers } from "@/customer/query";
import { getCustomerNameAndPhone } from "@/customer/utils";

interface AdvocateSelectorProps {
  businessId?: string;
  value: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  fullWidth?: boolean;
  // error?: string;
  required?: boolean;
  onAddNew?: () => void;
  addNewLabel?: string;
}

export const AdvocateSelector = ({
  businessId,
  value,
  onChange,
  label = "Advocate",
  placeholder = "Advocate",
  fullWidth = false,
  required = false,
  onAddNew,
  addNewLabel,
}: AdvocateSelectorProps) => {
  const [advocateSearch, setAdvocateSearch] = useState("");
  const { data: advocates = [], isLoading } = useGetCustomers(businessId);

  const advocateOptions = useMemo(
    () =>
      advocates.map((advocate) => ({
        value: advocate.id,
        label: getCustomerNameAndPhone(advocate) || "",
      })),
    [advocates],
  );

  return (
    <AutoComplete
      label={label}
      selectedValue={value}
      onSelectedValueChange={onChange}
      searchValue={advocateSearch}
      onSearchValueChange={setAdvocateSearch}
      items={advocateOptions.filter((option) =>
        option.label.toLowerCase().includes(advocateSearch.toLowerCase()),
      )}
      isLoading={isLoading}
      emptyMessage="No advocates found"
      placeholder={placeholder}
      // error={error}
      required={required}
      fullWidth={fullWidth}
      onAddNew={onAddNew}
      addNewLabel={addNewLabel}
    />
  );
};
